var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.edit)?_c('div',{staticClass:"rubric-feedback"},[_c('b-textarea',{staticClass:"apprentice-textarea",attrs:{"placeholder":_vm.$t('rubrics.give_feedback'),"rows":"4","max-rows":"4"},model:{value:(_vm.feedback),callback:function ($$v) {_vm.feedback=$$v},expression:"feedback"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }